// LOUMONT — Page unique suivi commande + precommande V23.84; Worker admin V23.83 conserve
(function(){
  'use strict';
  var stageSvgs = [
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16v13H4V7Zm2-4h12v3H6V3Zm4 7v3h4v-3h-4Z" fill="currentColor"/></svg>',
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M8 3h8l5 4-2.5 5L16 10.8V21H8V10.8L5.5 12 3 7l5-4Zm2 2c.3 1 1.1 1.5 2 1.5S13.7 6 14 5h-4Z"/></svg>',
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 2 8 4v6c0 5-3.3 9.4-8 10-4.7-.6-8-5-8-10V6l8-4Zm4.2 7.7-1.4-1.4-4.1 4.1-1.5-1.5-1.4 1.4 2.9 2.9 5.5-5.5Z" fill="currentColor"/></svg>',
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2 6h13v10H2V6Zm13 3h4l3 4v3h-7V9ZM6 17a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm12 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z" fill="currentColor"/></svg>',
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 2 10 6v13H2V8l10-6Zm0 3L5 9v9h4v-6h6v6h4V9l-7-4Z" fill="currentColor"/></svg>',
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 2 9 5v10l-9 5-9-5V7l9-5ZM5 9v7l6 3.3v-7L5 9Zm14 0-6 3.3v7l6-3.3V9Z" fill="currentColor"/></svg>',
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 2 10 8h-3v11h-6v-6h-2v6H5V10H2l10-8Zm0 3L7 9v10h2v-6h6v6h2V9l-5-4Z" fill="currentColor"/></svg>'  ];

  function formatDate(value){
    if(!value) return 'À confirmer';
    var match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value));
    if(!match) return 'À confirmer';
    var d = new Date(value + 'T12:00:00Z');
    if(Number.isNaN(d.getTime())) return 'À confirmer';
    return d.toLocaleDateString('fr-FR', {day:'numeric',month:'long',year:'numeric',timeZone:'UTC'});
  }
  function formatTimestamp(value){
    if(!value) return '';
    var d = new Date(value);
    return Number.isNaN(d.getTime()) ? '' : d.toLocaleDateString('fr-FR',{day:'numeric',month:'long',year:'numeric'});
  }
  function imageUrl(value){
    try {
      var u = new URL(String(value || ''));
      if(u.protocol === 'https:' && (u.hostname === 'cdn.shopify.com' || u.hostname.endsWith('.shopify.com') || u.hostname.endsWith('.myshopify.com'))) return u.href;
    } catch(e){}
    return '';
  }
  function single(root,selector){ return root.querySelector(selector); }

  function cardFor(root, template, item, stages){
    var card = template.content.firstElementChild.cloneNode(true);
    var label = String(item.product_title || 'Votre vêtement');
    var series = item.batch_number == null ? '' : ' · Série ' + item.batch_number;
    single(card,'.lmpt__product-title').textContent = label + series + (Number(item.quantity||1)>1?' · ×'+item.quantity:'');
    single(card,'.lmpt__status-text').textContent = item.stage_label || 'Suivi en préparation';
    var img=single(card,'.lmpt__image img');
    var placeholder=single(card,'.lmpt__placeholder');
    var url=imageUrl(item.image_url);
    if(url){img.src=url;img.hidden=false;placeholder.hidden=true;}
    else {img.hidden=true;placeholder.hidden=false;img.removeAttribute('src');}

    if(item.tracking_available === false){
      card.dataset.published="false";
      single(card,'.lmpt__summary-card').hidden=true;
      single(card,'.lmpt__progress').hidden=true;
      single(card,'.lmpt__timeline').hidden=true;
      single(card,'.lmpt__news').hidden=true;
      single(card,'.lmpt__dates').hidden=true;
      single(card,'.lmpt__disclaimer').hidden=true;
      single(card,'.lmpt__subheading').hidden=true;
      var note=document.createElement('p');
      note.className='lmpt__unpublished';
      note.textContent='Le suivi de fabrication de cet article n’est pas encore publié. Notre équipe le mettra à jour dès que les informations seront confirmées.';
      card.appendChild(note);
      return card;
    }

    var step = Math.max(0,Math.min(stages.length-1,Number(item.step)||0));
    var visibleStep = step + 1;
    var width = stages.length ? (visibleStep / stages.length) * 100 : 0;
    var bar = single(card,'.lmpt__bar');
    single(card,'.lmpt__stepcount').textContent='Étape '+visibleStep+' / '+stages.length;
    var progressBar = bar;
    progressBar.style.setProperty('width',width.toFixed(2)+'%','important');
    progressBar.style.setProperty('background-color','#171717','important');
    progressBar.style.setProperty('background-image','none','important');
    progressBar.setAttribute('role','progressbar');
    progressBar.setAttribute('aria-valuemin','0');
    progressBar.setAttribute('aria-valuemax','100');
    progressBar.setAttribute('aria-valuenow', String(Math.round(width)));
    bar.style.maxWidth = '100%';
    bar.setAttribute('aria-valuenow', String(Math.round(width)));

    var ship=formatDate(item.ship_date);
    single(card,'.lmpt__eta-main').textContent=ship==='À confirmer' ? 'Expédition à confirmer' : 'Expédition estimée : '+ship;
    single(card,'.lmpt__eta-next').textContent=step<stages.length-1
      ? 'Prochaine étape : '+stages[step+1]
      : 'Toutes les étapes de fabrication ont été franchies.';

    var timeline=single(card,'.lmpt__timeline');
    timeline.replaceChildren();
    stages.forEach(function(name,i){
      var status=i<step?'done':i===step?'active':'upcoming';
      var el=document.createElement('div');el.className='lmpt__stage';el.dataset.status=status;
      var icon=document.createElement('span');icon.className='lmpt__stage-icon';
      if(status==='done'){
        var checked=document.createElement('span');checked.className='lmpt__stage-check';checked.textContent='✓';icon.appendChild(checked);
      }else {
        var pict=document.createElement('span');pict.className='lmpt__stage-svg';
        pict.innerHTML=stageSvgs[i]||stageSvgs[stageSvgs.length-1];icon.appendChild(pict);
      }
      var wrap=document.createElement('div');wrap.className='lmpt__stage-text';
      var nameEl=document.createElement('strong');nameEl.textContent=name;
      var detail=document.createElement('small');detail.textContent=status==='done'?'Terminée':status==='active'?'Étape actuelle':'À venir';
      wrap.append(nameEl,detail);el.append(icon,wrap);timeline.appendChild(el);
    });

    single(card,'.lmpt__note').textContent=item.note||'Notre équipe suit votre précommande et partagera les dernières nouvelles dès leur confirmation.';
    single(card,'.lmpt__updated').textContent=item.updated_at?'Dernière mise à jour : '+formatTimestamp(item.updated_at):'';
    single(card,'.lmpt__stock').textContent=formatDate(item.stock_date);
    single(card,'.lmpt__ship').textContent=ship;
    single(card,'.lmpt__delivery').textContent=item.delivery_from ? (
      item.delivery_to && item.delivery_to!==item.delivery_from ?
        formatDate(item.delivery_from)+' – '+formatDate(item.delivery_to) : formatDate(item.delivery_from)
    ) : 'À confirmer';

    var updates=Array.isArray(item.updates)?item.updates:[];
    var journal=single(card,'.lmpt__journal');journal.replaceChildren();
    single(card,'.lmpt__journal-wrap').hidden=updates.length===0;
    updates.forEach(function(update){
      var row=document.createElement('div');row.className='lmpt__journal-entry';
      var date=document.createElement('strong');date.textContent=formatTimestamp(update.created_at);
      var message=document.createElement('p');message.textContent=String(update.body||'');
      row.append(date,message);journal.appendChild(row);
    });
    return card;
  }



function shipmentStageSvgs(){
  return [
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2a3 3 0 0 1 3 3v1h3a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3V5a3 3 0 0 1 3-3Zm1 4V5a1 1 0 1 0-2 0v1h2Zm-5 4h8v2H8v-2Z" fill="currentColor"/></svg>',
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 4h14a1 1 0 0 1 1 1v14H4V5a1 1 0 0 1 1-1Zm2 4v7h10V8H7Zm2 2h6v3H9v-3Z" fill="currentColor"/></svg>',
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7.5 12 4l8 3.5v9L12 20l-8-3.5v-9Zm8 5.8 5.5-2.3-1.7-.7L12 11.8 8.2 10.3l-1.7.7L12 13.3Z" fill="currentColor"/></svg>',
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2 6h13v10H2V6Zm13 3h4l3 4v3h-7V9ZM6 17a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm12 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z" fill="currentColor"/></svg>',
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 4h16v10H4V4Zm2 2v6h12V6H6Zm5 9 5-3v7H8v-7l3 3Z" fill="currentColor"/></svg>',
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 3 9 7v10H3V10l9-7Zm0 2.5L5 10v8h14v-8l-7-4.5Zm-3 5h6v6H9v-6Z" fill="currentColor"/></svg>'
  ];
}

function child(tag, className, text){
  var element=document.createElement(tag);
  if(className)element.className=className;
  if(text!==undefined)element.textContent=String(text);
  return element;
}

function parcelUrl(url){
  try {
    var parsed=new URL(String(url||''));
    return parsed.protocol==='https:' ? parsed.href : '';
  } catch(e) { return ''; }
}


function statusOf(order){
  var rows=Array.isArray(order.tracking)?order.tracking:[];
  var states=rows.map(function(row){
    if(row.deliveredAt) return 'DELIVERED';
    return String(row.status||'').trim().toUpperCase();
  }).filter(function(x){ return x!==''; });
  var fulfilled=order.status==='FULFILLED'||order.status==='PARTIALLY_FULFILLED';
  var status={code:'PREPARING',label:'Préparation',title:'Votre commande est en préparation.'};
  if(rows.length && rows.every(function(row){ return !!row.deliveredAt; })) return {code:'DELIVERED',label:'Livrée',title:'Votre colis a été livré.'};
  if(states.some(function(x){ return x==='FAILURE'||x==='NOT_DELIVERED'; })) return {code:'INCIDENT',label:'Incident',title:'Le transporteur signale un problème.'};
  if(states.includes('ATTEMPTED_DELIVERY')) return {code:'INCIDENT',label:'Tentative de livraison',title:'Une livraison a été tentée.'};
  if(states.includes('DELAYED')) return {code:'DELAYED',label:'Livraison retardée',title:'Votre colis a du retard.'};
  if(states.includes('READY_FOR_PICKUP')) return {code:'PICKUP',label:'En point relais',title:'Votre colis vous attend au point relais.'};
  if(states.includes('OUT_FOR_DELIVERY')) return {code:'OUT_FOR_DELIVERY',label:'En livraison',title:'Votre colis est en cours de livraison.'};
  if(states.includes('IN_TRANSIT')||states.includes('PICKED_UP')||states.includes('CARRIER_PICKED_UP')) return {code:'IN_TRANSIT',label:'En transport',title:'Votre colis est en route.'};
  if(rows.length){
    if(states.includes('INFO_RECEIVED')||states.includes('PRE_TRANSIT')||states.includes('LABEL_CREATED')||states.includes('LABEL_PRINTED')||states.includes('PENDING')||states.includes('CONFIRMED')||states.includes('UNKNOWN')||states.length===0){
      return {code:'LABEL_CREATED',label:'Traitée',title:'Votre commande a été traitée. Le colis n’a pas encore été scanné par le transporteur.'};
    }
    return {code:'SHIPPED',label:'Expédiée',title:'Votre colis a été remis au transporteur.'};
  }
  if(fulfilled) return {code:'LABEL_CREATED',label:'Traitée',title:'Votre commande a été traitée. L’étiquette de transport a été créée.'};
  if(order.status==='CANCELLED') return {code:'CANCELLED',label:'Annulée',title:'Cette commande a été annulée.'};
  return status;
}

function shipmentProgress(order,status,hasPreorders){
  var code=status.code;
  var stageDefs=[
    {label:String(order.financialStatus||'').toUpperCase()==='PAID'?'Commande payée':'Commande confirmée'},
    {label:'Préparation'},
    {label:'Traitée'},
    {label:'Expédiée'},
    {label:'En transport'},
    {label:code==='PICKUP'?'À retirer':'Livraison'}
  ];
  var activeIndex=1;
  if(code==='CANCELLED') activeIndex=0;
  else if(code==='PREPARING') activeIndex=1;
  else if(code==='LABEL_CREATED') activeIndex=2;
  else if(code==='SHIPPED') activeIndex=3;
  else if(code==='IN_TRANSIT'||code==='OUT_FOR_DELIVERY'||code==='INCIDENT'||code==='DELAYED') activeIndex=4;
  else if(code==='DELIVERED'||code==='PICKUP') activeIndex=5;

  var wrap=child('section','lmpt__shipment-progress');
  wrap.appendChild(child('div','lmpt__shipment-progress-heading','ÉTAPES DE LA LIVRAISON'));
  var barTrack=child('div','lmpt__shipment-progress-track');
  barTrack.setAttribute('role','progressbar');
  barTrack.setAttribute('aria-valuemin','0');
  barTrack.setAttribute('aria-valuemax',String(stageDefs.length-1));
  barTrack.setAttribute('aria-valuenow',String(activeIndex));
  barTrack.setAttribute('aria-label','Progression confirmée du suivi de colis');
  var fill=child('span','lmpt__shipment-progress-fill');
  var fillPercent = stageDefs.length>1 ? (activeIndex/(stageDefs.length-1))*100 : 0;
  fill.style.width=fillPercent+'%';
  barTrack.appendChild(fill);
  wrap.appendChild(barTrack);

  var steps=child('div','lmpt__shipment-steps');
  var icons=shipmentStageSvgs();
  stageDefs.forEach(function(def,index){
    var step=child('div','lmpt__shipment-step');
    var done=index<activeIndex || ((code==='DELIVERED'||code==='PICKUP') && index===activeIndex);
    var current=index===activeIndex && !(code==='DELIVERED'||code==='PICKUP');
    if(done) step.classList.add('is-done');
    else if(current) step.classList.add('is-current');
    else step.classList.add('is-future');
    var icon=child('span','lmpt__shipment-step-icon');
    icon.innerHTML = icons[index] || icons[icons.length-1];
    var label=child('span','lmpt__shipment-step-label',def.label);
    step.append(icon,label);
    steps.appendChild(step);
  });
  wrap.appendChild(steps);

  if(code==='LABEL_CREATED') wrap.appendChild(child('p','lmpt__shipment-progress-note','Votre commande a été traitée : l’étiquette est créée, mais le colis n’a pas encore été scanné par le transporteur.'));
  if(code==='INCIDENT'||code==='DELAYED') wrap.appendChild(child('p','lmpt__shipment-warning','Le transporteur signale un incident. Consultez le lien de suivi du colis pour les dernières informations.'));
  if(hasPreorders) wrap.appendChild(child('p','lmpt__shipment-progress-note','Ces étapes concernent uniquement les colis expédiés, pas les articles encore en fabrication.'));
  return wrap;
}

function normalTrackingCard(order,hasPreorders){
  var parcelRows=Array.isArray(order.tracking)?order.tracking:[];
  // Le suivi de fabrication est prioritaire lorsqu'aucun colis n'est encore expédié.
  if(hasPreorders&&!parcelRows.length)return null;
  var status=statusOf(order);
  if(hasPreorders && status.label==='Livrée') {
    status={label:'Colis livré',title:'Un colis de votre commande a été livré.'};
  } else if(hasPreorders && status.label==='Expédition enregistrée') {
    status={label:'Colis expédié',title:'Un colis de votre commande a été expédié.'};
  } else if(hasPreorders && status.label==='Expédiée') {
    status={label:'Colis expédié',title:'Votre colis a été remis au transporteur.'};
  } else if(hasPreorders && status.label==='Traitée') {
    status={label:'Colis traité',title:'Le colis de votre commande est prêt à être remis au transporteur.'};
  }
  var card=child('section','lmpt__shipment-card');
  card.appendChild(child('span','lmpt__micro','SUIVI DE COMMANDE'));
  card.appendChild(child('h2','lmpt__shipment-title',status.title));
  var badge=child('span','lmpt__shipment-badge',status.label);
  card.appendChild(badge);
  card.appendChild(shipmentProgress(order,status,hasPreorders));
  if(!parcelRows.length){
    card.appendChild(child('p','lmpt__shipment-description',
      'Aucun numéro de suivi de colis disponible pour le moment. Il sera affiché après l’expédition.'));
  }else{
    if(hasPreorders)card.appendChild(child('p','lmpt__shipment-description',
      'Ces informations concernent uniquement les colis déjà pris en charge. Vos articles en précommande sont suivis séparément ci-dessous.'));
    var list=child('div','lmpt__parcel-list');
    parcelRows.forEach(function(item){
      var box=child('div','lmpt__parcel');
      box.appendChild(child('span','lmpt__micro','TRANSPORTEUR'));
      box.appendChild(child('strong','lmpt__parcel-company',item.company||'Transporteur'));
      if(item.number){
        box.appendChild(child('span','lmpt__micro','NUMÉRO DE SUIVI'));
        box.appendChild(child('span','lmpt__parcel-number',item.number));
      }
      var href=parcelUrl(item.url);
      if(href){
        var link=child('a','lmpt__parcel-link','Suivre mon colis ↗');
        link.href=href;link.target='_blank';link.rel='noopener noreferrer';box.appendChild(link);
      }
      list.appendChild(box);
    });
    card.appendChild(list);
  }
  return card;
}

function init(root){
  if(root.dataset.lmptInitialized==='true')return;
  root.dataset.lmptInitialized='true';
  var original=String(root.dataset.endpoint||'').replace(/\/+$/,'');
  var endpoint=original.endsWith('/order')?original:original+'/order';
  var classicEndpoint=String(root.dataset.classicEndpoint||'/apps/suivi-commande');
  if(!classicEndpoint.startsWith('/')||classicEndpoint.startsWith('//'))classicEndpoint='/apps/suivi-commande';
  var form=single(root,'.lmpt__lookup');
  var orderInput=single(root,'.lmpt__order-input');
  var emailInput=single(root,'.lmpt__email-input');
  var button=single(root,'.lmpt__lookup-button');
  var state=single(root,'.lmpt__state');
  var summary=single(root,'.lmpt__order-summary');
  var results=single(root,'.lmpt__results');
  var template=single(root,'.lmpt__result-template');
  var controller=null;
  function message(text,error){
    state.textContent=text;state.dataset.error=error?'true':'false';state.hidden=!text;
  }
  if(!original){message('Le suivi n’est pas encore configuré.',true);return;}
  try{if(new URL(endpoint).protocol!=='https:')throw Error('endpoint');}
  catch(e){message('Configuration du suivi indisponible.',true);return;}

  form.addEventListener('submit',function(event){
    event.preventDefault();
    var order=orderInput.value.trim();
    var email=emailInput.value.trim().toLowerCase();
    if(!/^[#]?[a-z0-9][a-z0-9_-]{0,39}$/i.test(order)){
      message('Indiquez votre numéro de commande (par exemple #5746).',true);orderInput.focus();return;
    }
    if(!email||!emailInput.validity.valid){
      message('Indiquez l’adresse e-mail utilisée pour cette commande.',true);emailInput.focus();return;
    }
    if(controller)controller.abort();
    controller=new AbortController();
    var request=controller;
    button.disabled=true;button.textContent='RECHERCHE EN COURS…';
    results.replaceChildren();summary.hidden=true;
    message('Recherche de votre commande…',false);

    // 1. La recherche Shopify existante valide la commande et l'e-mail.
    fetch(classicEndpoint,{
      method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      credentials:'same-origin',cache:'no-store',signal:request.signal,
      body:JSON.stringify({orderNumber:order,email:email})
    }).then(function(response){
      return response.json().catch(function(){return {};}).then(function(data){
        if(!response.ok||!data.success||!data.order){
          throw Error(data.message||'Impossible de retrouver cette commande. Vérifiez le numéro et l’e-mail.');
        }
        return data.order;
      });
    }).then(function(shopifyOrder){
      // 2. Une seule recherche complémentaire pour les suivis de production.
      return fetch(endpoint,{
        method:'POST',mode:'cors',credentials:'omit',cache:'no-store',signal:request.signal,
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({order_number:order,email:email})
      }).then(function(response){
        return response.json().catch(function(){return {};}).then(function(data){
          if(response.status===404)return {shopifyOrder:shopifyOrder,preorders:[],stages:[],note:''};
          if(!response.ok||!data.success)return {
            shopifyOrder:shopifyOrder,preorders:[],stages:[],
            note:'Le suivi de fabrication est momentanément indisponible. Les informations de livraison restent accessibles ci-dessous.'
          };
          return {shopifyOrder:shopifyOrder,preorders:Array.isArray(data.tracking)?data.tracking:[],stages:Array.isArray(data.stages)?data.stages:[],note:''};
        });
      }).catch(function(error){
        if(error.name==='AbortError')throw error;
        return {shopifyOrder:shopifyOrder,preorders:[],stages:[],
          note:'Le suivi de fabrication est momentanément indisponible. Réessayez ultérieurement.'};
      });
    }).then(function(data){
      if(request!==controller)return;
      var items=data.preorders;
      var stages=data.stages;
      var fragment=document.createDocumentFragment();
      var number=String(data.shopifyOrder.number||order);
      var hasPreorder=items.length>0;
      var normal=normalTrackingCard(data.shopifyOrder,hasPreorder);
      if(normal)fragment.appendChild(normal);
      if(hasPreorder){
        var header=child('h2','lmpt__preorder-heading',items.length>1?'Vos articles en précommande':'Votre article en précommande');
        fragment.appendChild(header);
        items.forEach(function(item){fragment.appendChild(cardFor(root,template,item,stages));});
      }
      if(data.note)fragment.appendChild(child('p','lmpt__unified-notice',data.note));
      results.replaceChildren(fragment);
      summary.textContent=number+' · '+(hasPreorder?'Suivi de précommande et de livraison':'Suivi de livraison');
      summary.hidden=false;
      message('',false);
      if(document.activeElement instanceof HTMLElement)document.activeElement.blur();
      results.scrollIntoView({behavior:'smooth',block:'start'});
    }).catch(function(error){
      if(error.name==='AbortError')return;
      message(error instanceof TypeError?'Connexion impossible au suivi de commande. Réessayez dans quelques instants.':String(error.message||'Erreur de suivi.'),true);
    }).finally(function(){
      if(request!==controller)return;
      button.disabled=false;button.innerHTML='VOIR MON SUIVI <span aria-hidden="true">↗</span>';
    });
  });
}
  function boot(scope){
    if(scope.matches && scope.matches('.lmpt')) init(scope);
    if(scope.querySelectorAll) scope.querySelectorAll('.lmpt').forEach(init);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){boot(document);});
  else boot(document);
  document.addEventListener('shopify:section:load',function(event){boot(event.target);});
})();
